/**
 * Product descriptions arrive from the catalog as merchant-authored HTML
 * (`<h3 data-start=..>`, `&aacute;`, `<br />`). The widget shows them as PLAIN
 * TEXT: DOMParser builds an inert document (no scripts run, no images load),
 * and only its text survives, so no tag, attribute or handler can reach the
 * widget DOM. Entities are decoded by the parser.
 */
export function htmlToText(html: string | undefined | null): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html.replace(/\s+/g, ' '), 'text/html');
  doc.querySelectorAll('script,style').forEach((e) => e.remove());
  doc.querySelectorAll('br,p,div,h1,h2,h3,h4,h5,h6,li,tr').forEach((e) => e.replaceWith('\n', e, '\n'));
  return doc.body.textContent!.replace(/\s*\n\s*/g, '\n').trim();
}
